export const GET_COMMON_DATA = 'GET_COMMON_DATA';
export const GET_FOOTER_DATA = 'GET_FOOTER_DATA';
export const GET_ANNOUNCEMENT_TITLE = 'GET_ANNOUNCEMENT_TITLE';
export const GET_ANNOUNCEMENT_BODY = 'GET_ANNOUNCEMENT_BODY';
export const GET_ANNOUNCEMENT_LEARN_MORE = 'GET_ANNOUNCEMENT_LEARN_MORE';
export const UPDATE_COMMON_DATA = 'UPDATE_COMMON_DATA';
export const UPDATE_ANNOUNCEMENT_DATA = 'UPDATE_ANNOUNCEMENT_DATA';
export const UPDATE_FOOTER_DATA = 'UPDATE_FOOTER_DATA';
export const POST_CONTACT_US = 'POST_CONTACT_US';
export const INFOBLOCK_FROM_LINK = 'INFOBLOCK_FROM_LINK';